import { styled } from '@material-ui/core'

export const CenteredLoading = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50vh'
})
